import _ from 'lodash';
import { DiscountEligibility } from '../../constants';

const formatStateroomsForRequest = (stateroom, cruiseLineId) => {
  const doIncludePastPassenger =
    !stateroom.discounts ||
    (stateroom.discounts || []).includes(DiscountEligibility.PAST_PASSENGER);
  let pastPassengerNumber =
    doIncludePastPassenger &&
    stateroom.pastPassengerNumbers &&
    cruiseLineId > 0 &&
    (_.find(stateroom.pastPassengerNumbers, (p) => p && +p.cruiseLineId === cruiseLineId) || {})
      .value;
  if (doIncludePastPassenger && !pastPassengerNumber && stateroom.pastPassengerNumber) {
    pastPassengerNumber = stateroom.pastPassengerNumber;
  }
  const s = {
    ...stateroom,
    pastPassengerNumber,
    passengerOccupation:
      !stateroom.discounts || (stateroom.discounts || []).includes(DiscountEligibility.OCCUPATION)
        ? stateroom.passengerOccupation
        : null,
    passengerFirstName: pastPassengerNumber ? stateroom.passengerFirstName : undefined,
    passengerMiddleName: pastPassengerNumber ? stateroom.passengerMiddleName : undefined,
    passengerLastName: pastPassengerNumber ? stateroom.passengerLastName : undefined,
  };
  delete s.pastPassengerNumbers;
  if (!s.passengerOccupation) delete s.passengerOccupation;
  if (!s.pastPassengerNumber) delete s.pastPassengerNumber;
  return s;
};

export default formatStateroomsForRequest;
